export function useDynamicIconComponent() {
  // Cache icon components to prevent duplicate imports
  const iconCache = new Map<string, ReturnType<typeof defineAsyncComponent>>();

  const getIconComponent = (iconName: string) => {
    if (!iconCache.has(iconName)) {
      iconCache.set(
        iconName,
        defineAsyncComponent(() => import(`@/components/icon/${iconName}.vue`)),
      );
    }
    return iconCache.get(iconName);
  };

  return { getIconComponent };
}
